import IRequest from "../../IRequest"

export interface IDataAgronomo {
    id: number,
    nome: string
    crea: string
    telefone: number
    loja_id: number
    quantidade_receitas_art: number
    receitas_emitidas: number
}

export interface IAgronomos {
    reqAgronomo: IRequest<IDataAgronomo>,
    dataAgronomo: IDataAgronomo[]
}

export const defValueAgronomo: IDataAgronomo = {
    id: 0,
    nome: "",
    crea: "",
    telefone: 0,
    loja_id: 0,
    quantidade_receitas_art: 0,
    receitas_emitidas: 0
}
